import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="dashboard-loading" style={{ minHeight: '60vh' }}>
      <h1 style={{ fontSize: 'var(--font-size-4xl)', marginBottom: 'var(--spacing-4)' }}>404</h1>
      <p style={{ marginBottom: 'var(--spacing-6)' }}>Page not found</p>
      <Link to="/" className="btn btn-primary">
        Go to Dashboard
      </Link>
    </div>
  );
};

export default NotFound;
